import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import { useApp } from "../context/AppContext";

function ResetPassword() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  const [valid, setValid] = useState(null); // null=checking, true, false
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setValid(false); return; }
    axios.get(`/api/reset-password/${token}`)
      .then(() => setValid(true))
      .catch(() => setValid(false));
  }, [token]);

  const onSubmit = async e => {
    e.preventDefault(); setError("");
    if (password !== confirm) { setError(t("passwordMismatch")); return; }
    setBusy(true);
    try {
      await axios.post("/api/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    } finally { setBusy(false); }
  };

  return (
    <section className="section container">
      <div className="auth-wrap">
        <div className="center" style={{ marginBottom: 24 }}>
          <span className="eyebrow">{t("memberAccess")}</span>
          <h1 className="section-title">{t("resetTitle")}</h1>
        </div>
        <div className="card-panel">
          {valid === null && <p className="hint center">{t("loading")}</p>}
          {valid === false && (
            <div style={{ textAlign: "center" }}>
              <div className="alert alert-error">{t("resetExpired")}</div>
              <Link to="/forgot-password" style={{ marginTop: 16, display: "inline-block" }}>{t("forgotPassword")}</Link>
            </div>
          )}
          {valid && done && (
            <div style={{ textAlign: "center" }}>
              <div className="alert alert-success">{t("resetSuccess")}</div>
              <Link to="/login" style={{ marginTop: 16, display: "inline-block" }}>{t("signIn")}</Link>
            </div>
          )}
          {valid && !done && (
            <form onSubmit={onSubmit}>
              {error && <div className="alert alert-error">{error}</div>}
              <div className="field">
                <label>{t("newPassword")}</label>
                <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} autoFocus />
                <div className="hint">{t("passwordHint")}</div>
              </div>
              <div className="field">
                <label>{t("confirmPassword")}</label>
                <input className="input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={6} />
              </div>
              <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={busy}>
                {busy ? t("sending") : t("setPassword")}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
export default ResetPassword;
